import React, { useState, useEffect } from "react";
import "../../assets/css/FloatingWhatsapp.css";

const FloatingWhatsapp = () => {
  const [whatsappUrl, setWhatsappUrl] = useState("https://wa.me/");

  const resolveUrl = () => {
    try {
      const raw = localStorage.getItem("sitSetting");
      if (!raw) return "https://wa.me/";
      const setting = JSON.parse(raw);
      const contact =
        setting?.whatsappSupport ||
        setting?.supportWhatsapp ||
        setting?.CompanyMobile ||
        setting?.Mobile;

      if (!contact) return "https://wa.me/";

      if (
        contact.startsWith("http://") ||
        contact.startsWith("https://") ||
        contact.startsWith("whatsapp://")
      ) {
        return contact;
      }

      const digits = String(contact).replace(/[^\d]/g, "");
      if (!digits) return "https://wa.me/";

      const message = encodeURIComponent(
        "Hello King Master Support, I need assistance."
      );
      return `https://wa.me/${digits}?text=${message}`;
    } catch (e) {
      return "https://wa.me/";
    }
  };

  useEffect(() => {
    setWhatsappUrl(resolveUrl());

    const handleStorage = () => {
      setWhatsappUrl(resolveUrl());
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const handleClick = (e) => {
    const freshUrl = resolveUrl();
    if (freshUrl && freshUrl !== "https://wa.me/") {
      // standard navigation to link
      return;
    }
    // If no custom number configured, just open wa.me
  };

  return (
    <div className="floating-whatsapp-wrapper" aria-hidden="false">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp-btn"
        title="Chat with WhatsApp Support"
        aria-label="Chat with WhatsApp Support"
        onClick={handleClick}
      >
        <img
          src="/images/whatsapp.png"
          alt="WhatsApp Support"
          className="floating-whatsapp-img"
          loading="lazy"
        />
      </a>
    </div>
  );
};

export default FloatingWhatsapp;
